"use client";

import { m, useReducedMotion } from "motion/react";
import { AiScanIcon } from "@carpybara/ui/icons";

type Props = {
  size?: number;
  className?: string;
};

const AI_SCAN_MOTION = {
  y: [0, -4, 0],
  rotate: [-1, 1, -1],
  scale: [1, 1.025, 1],
};

const AI_SCAN_TRANSITION = {
  duration: 2.6,
  repeat: Infinity,
  ease: "easeInOut" as const,
};

export function AiScanCapybaraScene({ size = 112, className = "" }: Props) {
  const shouldReduceMotion = useReducedMotion() === true;

  return (
    <m.div
      className={`shrink-0 select-none ${className}`}
      style={{ width: size, height: size }}
      animate={shouldReduceMotion ? undefined : AI_SCAN_MOTION}
      transition={AI_SCAN_TRANSITION}
      aria-hidden="true"
    >
      <AiScanIcon size={size} />
    </m.div>
  );
}
